import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function documentReducer(state = initialState.document, action) {
  switch (action.type) {
    case types.LOAD_DOCUMENT_SUCCESS:
    case types.UPDATE_DOCUMENT_SUCCESS:
      return action.document;
    case types.INVALIDATE_DOCUMENT_STATE:
      return initialState.document;
    default:
      return state;
  }
}
